'use strict';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Backbone from 'backbone';
import router from 'Router';
import { formatDateToAPI } from "D5Utils/functions";
export var A = {
  extend: function extend() {}
};
export var Objects1 = {
  SysAppObjects: "Sys_AppObjects",
  SysFormFilterFields: "Sys_FormFilterFields",
  SysAppObjectOperations: "Sys_AppObjectOperations",
  SysSubsystems: "Sys_Subsystems",
  SysForms: "Sys_Forms",
  SysFormFields: "Sys_FormFields",
  SysFormGroups: "Sys_FormGroups",
  SysUsers: "Sys_Users",
  SysRoles: "Sys_Roles",
  SysRoleOperationAccess: "Sys_RoleOperationAccess",
  SysRoleFieldsRestriction: "Sys_RoleFieldsRestriction",
  SysRoleSubsystemAccess: "Sys_RoleSubsystemAccess",
  SysPositions: "Sys_Positions",
  SysPositionRoles: "Sys_PositionRoles",
  SysPositionAccess: "Sys_PositionAccess",
  SysUserPositions: "Sys_UserPositions",
  SysUserPositionAdditionAccess: "Sys_UserPositionAdditionAccess",
  SysFormButtons: "Sys_FormButtons",
  SysFormFieldEvents: "Sys_FormFieldEvents",
  SysSubForms: "Sys_SubForms",
  SysAppObjectFilters: "Sys_AppObjectFilters",
  SysFormButtonEvents: "Sys_FormButtonEvents",
  SysFormFilterFieldEvents: "Sys_FormFilterFieldEvents",
  SysFormDecorationElements: "Sys_FormDecorationElements"
};
export var Model = Backbone.Model.extend({
  /**
   * Extending native backbone fetch function (see documentation)
   * @param options - extended data for fetch
   * @return {*} - return and call native backbone fetch function
   */
  fetch: function fetch(options) {
    options.data = JSON.stringify(options.data);
    return Backbone.Model.prototype.fetch.call(this, options);
  },

  /**
   * Native backbone sync function (see documentation)
   */
  sync: function sync(method, model, options) {
    switch (method) {
      case "create":
        this.fields = Object.keys(model.attributes);
        this.prepareModelToSave();
        options.url = router.createUrl(method, model.object);
        break;

      case "read":
        options.url = router.createUrl(method, model.object);
        method = 'create';
        break;

      case "update":
        this.fields = Object.keys(model.attributes);
        this.prepareModelToSave();
        options.url = router.createUrl(method, model.object);
        method = 'create';
        break;

      case "delete":
        this.prepareModelToSave();
        options.url = router.createUrl(method, model.object);
        method = 'create';
        break;
    }

    if (!options.headers) options.headers = {};
    options.headers['Accept'] = 'application/DirectorWebApi.1.1+json';
    return Backbone.sync.call(this, method, model, options);
  },

  /**
   * Receive data from server and parse it (native backbone function, see documentation)
   * @param data - data from server
   * @return {*} - return parsed data
   */
  parse: function parse(data) {
    var modelData;

    if (!data.Response) {
      return;
    }

    modelData = data.Response[0] ? data.Response[0] : data.Response[this.object][0]; // modelData.RowKey = modelData[this.getKeyField()];

    return modelData;
  },

  /**
   * Prepare model to send it to the server for saving (used for edit existing model or for creating a new one)
   */
  prepareModelToSave: function prepareModelToSave() {
    var _this = this;

    var valuesForServer = _defineProperty({}, this.object, function () {
      var res = {};

      _.each(_this.toJSON(), function () {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var key = arguments.length > 1 ? arguments[1] : undefined;
        res[key] = value;
        if (value instanceof Date) res[key] = formatDateToAPI(value);
      });

      return [res];
    }());
    /** unset (delete) previous data if it editing model **/


    _.each(this.keys(), function (item) {
      _this.unset(item);
    });

    this.set("Request", valuesForServer);
  },

  /**
   * Filling model columns by model data
   * @param columns - full model columns
   * @return {Object} - returned model data
   */
  getDataByColumns: function getDataByColumns(columns) {
    var data = this.attributes;
    var newData = {};
    var field;
    var nestedFieldProps;
    var NestedObject;
    var NestedID;
    var NestedField;

    _.each(columns, function (index) {
      if (index.indexOf('.Columns.') > -1) {
        index = index.split('.')[2];
      }

      if (data.hasOwnProperty(index)) {
        field = this.fields[index];
        /** if field has format method call function for change data format depending on needs else push data as it is **/

        if (field && field.format) {
          newData[index] = this.format(data[index], field, index, data);
        } else {
          newData[index] = data[index];
        }
      } // Add values from NestedData


      if (index.indexOf('NestedColumns') === 0) {
        nestedFieldProps = index.split('.');
        NestedObject = nestedFieldProps[1];
        NestedID = nestedFieldProps[2];
        NestedField = _.findWhere(data[NestedObject], {
          PropID: parseInt(NestedID, 10)
        });

        if (NestedField) {
          newData[index] = NestedField.Value;
        } else {
          newData[index] = '&nbsp;';
        }
      }
    }.bind(this));

    return newData;
  },

  /**
   * Changing data format for rendering depending on needs
   */
  format: function format(data, field, fieldName, allData) {
    function pad(date) {
      return ("0" + date).slice(-2);
    }

    function formatDate(date) {
      return pad(date.getDate()) + '.' + pad(date.getMonth() + 1) + '.' + date.getFullYear();
    }

    if (field.format === 'nested') {
      return data && data[0] && data[0][field.viewField];
    }

    switch (field.type) {
      case "date":
        if (data === null) {
          return;
        }

        return formatDate(new Date(data));
      // case "checkbox":
      //     return checkLocalDictionary(field.type, data);

      case "text":
        if (field.format === "custom") {
          return this.formatters && this.formatters[fieldName] && this.formatters[fieldName](allData);
        }

        break;

      default:
        return data;
    }
  }
});